import { Card, Grid } from "@mui/material";
import { useMemo, useRef, useState } from "react";

import Box from "../../components/Box";
import RoleTabComponent from "./roleTab";
import Helpers from "../../commons/helpers";
import RoleEditComponent from "./edit/RoleEditComponent";
import HeaderButton from "../../components/HeaderButton";
import PolicyEditComponent from "./edit/PolicyEditComponent";
import { IPropDetailContainer, IRole } from "../../commons/interfaces";
import { MainComponent } from "../main";
import { Mode, RoleTab } from "../../constants/enums";
import { useCommonComponentContext } from "../../providers/CommonComponentProvider";
import { IDENTITY_SERVICE_CODE, RoleHelpers } from "../../commons/roleHelpers";

const RoleEditContainer = ({
    hidenActionCreate,
    hidenActionUpdate,
    hiddenTab,
    idDetail,
    onGoBack,
    onChangeMode,
    mode,
    tab = RoleTab.Role,
}: IPropDetailContainer & {
    tab?: RoleTab;
    hiddenTab?: boolean;
    hidenActionUpdate?: boolean;
    hidenActionCreate?: boolean;
}) => {
    const { userInfo, serviceCode } = useCommonComponentContext();
    const [selectedTab, setSelectedTab] = useState<RoleTab>(tab);
    const roleRef = useRef<HTMLButtonElement>();
    const policyRef = useRef<HTMLButtonElement>();
    const [roleDetail, setRoleDetail] = useState<IRole | undefined>(undefined);

    const acUpdate = useMemo(() => {
        if (RoleHelpers.isOrganizationUser(userInfo?.userProfile)) return roleDetail?.type !== userInfo?.userProfile?.roleType;
        if (!RoleHelpers.isOrganizationUser(userInfo?.userProfile) && serviceCode === IDENTITY_SERVICE_CODE) return true;
        if (!RoleHelpers.isOrganizationUser(userInfo?.userProfile) && serviceCode !== IDENTITY_SERVICE_CODE)
            return roleDetail?.type !== userInfo?.userProfile?.roleType;

        return !Helpers.isNullOrEmpty(idDetail);
    }, [idDetail, roleDetail, userInfo, serviceCode]);

    const onSubmit = () => {
        if (selectedTab === RoleTab.Role) roleRef.current?.click();
        if (selectedTab === RoleTab.Policy) policyRef.current?.click();
    };

    return (
        <MainComponent>
            <HeaderButton
                hidenActionCreate={mode === Mode.Create ? false : acUpdate || hidenActionCreate}
                hidenActionUpdate={!acUpdate || hidenActionUpdate}
                isEdited={false}
                mode={mode}
                onGoBack={onGoBack}
                onSubmit={onSubmit}
            />

            <Card>
                <Box p={3} display="grid" gap={2}>
                    {!hiddenTab && (
                        <Grid item xs={12}>
                            <RoleTabComponent tab={selectedTab} setTab={setSelectedTab} disabled={mode !== Mode.Create} />
                        </Grid>
                    )}
                    <Grid container spacing={0}>
                        <Grid item xs={12}>
                            {selectedTab === RoleTab.Role && (
                                <RoleEditComponent {...{ mode, onChangeMode, onGoBack, idDetail, bRef: roleRef, setRoleDetail }} />
                            )}
                            {selectedTab === RoleTab.Policy && (
                                <PolicyEditComponent {...{ mode, onChangeMode, onGoBack, idDetail, bRef: policyRef }} />
                            )}
                        </Grid>
                    </Grid>
                </Box>
            </Card>
        </MainComponent>
    );
};

export default RoleEditContainer;
